/**
 * Banners status text map .
 *
 * @type {{ IN_PROGRESS: string, UPCOMING: string, EXPIRED: string, UNKNOWN: string }}
 */
export const BANNERS_STATUS = {
    EXPIRED: 'Expired',
    IN_PROGRESS: 'In Progress',
    UPCOMING: 'Upcoming',
    UNKNOWN: 'Unknown',
};

/**
 * Type of product banners
 * @type {{ASK_A_PRO: string, HOMEPAGE: string, HANDBOOKS: string, LEARN: string}}
 */
export const PRODUCT_BANNER_TYPES = {
    HOMEPAGE: 'Homepage',
    LEARN: 'Learn',
    ASK_A_PRO: 'Ask a Pro',
    HANDBOOKS: 'Handbooks',
};

/**
 * `listType` values for the v3 banners list endpoint.
 *
 * @type {{LIVE: string, SCHEDULED: string, EXPIRED: string}}
 */
export const BANNER_V3_LIST_TYPES = {
    LIVE: 'active',
    SCHEDULED: 'scheduled',
    EXPIRED: 'expired',
};

/**
 * Per-section default `sort` for the v3 banners list endpoint.
 *
 * Live banners surface what expires next, scheduled banners what goes live
 * next, and expired banners the most recently ended first.
 *
 * @type {{LIVE: string, SCHEDULED: string, EXPIRED: string}}
 */
export const BANNER_V3_SECTION_SORTS = {
    LIVE: '+effectiveTill',
    SCHEDULED: '+effectiveFrom',
    EXPIRED: '-effectiveTill',
};

/**
 * Banner type labels for display in the UI.
 *
 * @type {{announcement: string, success: string, attention_required: string, critical_alert: string}}
 */
export const BANNER_TYPE_LABELS = {
    announcement: 'Announcement',
    success: 'Success',
    attention_required: 'Attention Required',
    critical_alert: 'Critical Alert',
};

/**
 * Banner status values from API.
 *
 * @type {{ACTIVE: string, INACTIVE: string}}
 */
export const BANNER_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};

/**
 * Banner status labels for display in the UI.
 *
 * @type {{active: string, inactive: string}}
 */
export const BANNER_STATUS_LABELS = {
    [BANNER_STATUS.ACTIVE]: 'Active',
    [BANNER_STATUS.INACTIVE]: 'Inactive',
};

/**
 * User-facing strings for the Banners list page.
 */
export const BANNERS_LIST_PAGE = {
    TITLE: 'Banners',
    SUBTITLE:
        'Manage platform banners and communications to display on the homepage, handbooks, Learn, and Ask a Pro.',
    CREATE_BUTTON: 'Create New Banner',
    SUB_NAV_TITLE: 'System Administration',
};

/**
 * Section configuration for the Banners list page.
 */
export const BANNERS_SECTIONS = {
    LIVE: {
        key: 'live',
        title: 'Live Banners',
        emptyStateText: 'There are no live banners.',
    },
    SCHEDULED: {
        key: 'scheduled',
        title: 'Scheduled Banners',
        emptyStateText: 'There are no scheduled banners.',
    },
    EXPIRED: {
        key: 'expired',
        title: 'Expired Banners',
        emptyStateText: 'There are no expired banners.',
    },
};

/**
 * Delete banner confirmation dialog strings.
 */
export const BANNER_DELETE_DIALOG = {
    TITLE: 'Delete Alert Banner',
    DESCRIPTION:
        'Are you sure you want to delete this alert banner? Deleting this alert banner will permanently remove it from the platform. This action cannot be undone.',
    CANCEL_TEXT: 'Cancel',
    CONFIRM_TEXT: 'Delete Banner',
};

/**
 * Default pagination limit (rows per page) for banner sections. Must match the
 * redesigned table's default `rowsPerPage` so the initial server page size, the
 * rendered rows and the footer's page count stay in sync.
 *
 * @type {number}
 */
export const BANNER_DEFAULT_LIMIT = 10;
